import { createPortal } from 'react-dom'

import { type IProps } from './portal.types'

export const Portal = ({ children }: IProps) => {
    return createPortal(children, document.body)
}
